import { Link } from 'react-router-dom';
import PlanGallery from '../components/PlanGallery';
import ClientTestimonials from '../components/ClientTestimonials';
import TeamMembers from '../components/TeamMembers';

const Home = () => {
  return (
    <>
      {/* Banner */}
      <div className="home-banner-area banner-two">
        <div className="container">
          <div className="row">
            <div className="col-lg-8 col-sm-12 offset-lg-2">
              <div className="banner-content">
                <h1>
                  We Are The World's Best <span>Dream</span> Builders
                </h1>
                <p>
                  You can dream, create, design, and build the most wonderful place in the world. But it requires people to make the dream a reality.
                </p>
                <div className="cta-btn">
                  <Link to="/projects" className="primary-btn">Explore Projects</Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* About Section */}
      <section id="about" className="about-section about-style-two pt-100 pb-70 bg-primary">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-7">
              <div className="about-img-content">
                <div className="row">
                  <div className="col-lg-6 col-md-6 pr-0">
                    <div className="about-image">
                      <img src="/assets/img/about/about-img-1.jpg" alt="About" />
                    </div>
                    <div className="about-fact">
                      <div className="content">
                        <h4>85+ Clients</h4>
                        <span>Satisfied By Us</span>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-6 pl-0">
                    <div className="about-fact ml-auto">
                      <div className="content">
                        <h4>12+ Years</h4>
                        <span>Of Experience</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="overlay-img">
                  <img src="/assets/img/about/555.jpeg" alt="About" />
                </div>
              </div>
            </div>
            <div className="col-lg-5">
              <div className="about-content">
                <h2>We Build Everything As Your <span>Dream</span></h2>
                <p>Welcome to the dawn of a new era in luxury living and architectural excellence. Desale Patil, a renowned name in the realm of construction and development, proudly unveils its latest masterpiece: 'The Rising' As the sun sets on conventional standards, our 10-floor marvel ascends to redefine urban living, embodying innovation, sophistication, and a commitment to crafting spaces that transcend expectations.</p>
                <p>Join us on a journey where each floor tells a story of modern elegance, and together, we build dreams that touch the sky.</p>
                <div className="about-item-list">
                  <ul>
                    <li><i className="flaticon-play-button"></i> 100% Satisfaction Guarantee.</li>
                    <li><i className="flaticon-play-button"></i> Accurate Testing Processes.</li>
                    <li><i className="flaticon-play-button"></i> 12+ Years Of Experience.</li>
                    <li><i className="flaticon-play-button"></i> Strong Building Materials.</li>
                    <li><i className="flaticon-play-button"></i> Eco-Friendly Build Materials.</li>
                  </ul>
                </div>
                <div className="cta-btn">
                  <Link to="/about" className="primary-btn">Explore About Us</Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section className="best-service-section ptb-100 bg-primary">
        <div className="container">
          <div className="section-title style-two">
            <h2>We Provide Best <span>Services</span></h2>
          </div>
          <div className="row">
            <div className="col-lg-4 col-md-6">
              <div className="service-item-single">
                <i><img src="/assets/img/icons/bricks.png" alt="Icon" /></i>
                <h3>Gabion Wall Construction</h3>
                <p>Gabion wall construction integrates wire mesh containers filled with stones, forming a robust, eco-friendly structure, combining with natural aesthetics for effective erosion control in diverse landscapes.</p>
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div className="service-item-single">
                <i><img src="/assets/img/icons/barrier.png" alt="Icon" /></i>
                <h3>Building Construction</h3>
                <p>Modern skyscraper, steel and glass façade, sustainable design, open floor plan, efficient systems, eco-friendly materials, blending aesthetics with functionality, architectural innovation, urban landmark.</p>
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div className="service-item-single">
                <i><img src="/assets/img/icons/brush.png" alt="Icon" /></i>
                <h3>Painting & Tiling</h3>
                <p>From dull to dazzling – where tiles meet strokes of brilliance, Coloring your world, tiling your dreams, Brushing life into every corner, one stroke at a time, Tiling dreams, painting realities</p>
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div className="service-item-single">
                <i><img src="/assets/img/icons/blueprint.png" alt="Icon" /></i>
                <h3>Steel Plant Construction</h3>
                <p>Leading steel plant company constructing cutting-edge facilities with advanced technologies, sustainable practices, and a commitment to safety, ensuring high-quality steel production for global industries.</p>
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div className="service-item-single">
                <i><img src="/assets/img/icons/measurement1.png" alt="Icon" /></i>
                <h3>Area Renovation</h3>
                <p>Innovation in renovation – turning your vision into a masterpiece, We Transform your space, elevate your living, Unlock the potential of your space with our renovation expertise.</p>
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div className="service-item-single">
                <i><img src="/assets/img/icons/concrete-mixer.png" alt="Icon" /></i>
                <h3>Factory & Shed Construction</h3>
                <p>Modern factory and shed construction with robust steel framework, spacious interiors, efficient layout, and durable roofing, designed for streamlined production and optimal workspace functionality.</p>
              </div>
            </div>
          </div>
          <div className="cta-btn text-center">
            <Link to="/projects" className="primary-btn">Explore Projects</Link>
          </div>
        </div>
      </section>

      {/* Finished Projects Section */}
      <section className="finished-projects-section style-two pt-100 pb-70 bg-primary">
        <div className="bg-image">
          <img src="/assets/img/project-bg-1.jpg" alt="Background" />
        </div>
        <div className="container">
          <div className="section-title">
            <h2>Our Current <span>Project</span> "The Rising"</h2>
          </div>
          <div className="row">
            <div className="col-lg-4 col-md-6 mb-4">
              <div className="slider-item">
                <div className="image">
                  <img src="/assets/img/projects/01.webp" alt="Project" />
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 mb-4">
              <div className="slider-item">
                <div className="image">
                  <img src="/assets/img/projects/02.webp" alt="Project" />
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 mb-4">
              <div className="slider-item">
                <div className="image">
                  <img src="/assets/img/projects/03.webp" alt="Project" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Plans and Details Section */}
      <section className="team-section team-two pt-100 pb-70">
        <div className="container">
          <div className="row align-items-stretch">
            <div className="col-lg-5 col-md-12">
              <div className="team-content">
                <h2 className="color-secondary">Our Plan and Details</h2>
                <div className="cta-btn">
                  <span className="primary-btn">Click On The Image</span>
                </div>
              </div>
            </div>
            <div className="col-lg-7 col-md-12 d-flex">
              <PlanGallery />
            </div>
          </div>
        </div>
      </section>

      {/* Client Testimonials Section */}
      <ClientTestimonials />

      {/* Team Members Section */}
      <TeamMembers />
    </>
  );
};

export default Home;
